import axios from 'axios';
export const getPage = async (root, id) => axios.get(`${root}/legacy/pages/${id}`).then((o) => o.data);
export { applyGateway } from '@pok/pages-sdk';
//# sourceMappingURL=pages.js.map